export const book = {
  title: "The Mentored Founder",
  subtitle: "Lessons from Empires and Exits for Building Your Next Company",
  author: "Henry Bernard Dotson IV",
  releaseDate: "November 1, 2026",
  preorderUrl: "https://api.leadconnectorhq.com/widget/form/KH0sUGpZgPz6bVTR4CW3",
  cover:
    "https://cdn.magicpatterns.com/uploads/uJYzSdWJaMdomh7pozwwmw/TheMentoredFounderCover_Final.png",
  authorPortrait:
    "https://cdn.magicpatterns.com/uploads/uGL5z8r3zGNQBFphwyoAXt/professionalphoto_whitebg.png",
};

export const navLinks = [
  { label: "About the Book", href: "#book" },
  { label: "What's Inside", href: "#inside" },
  { label: "About the Author", href: "#author" },
  { label: "FAQ", href: "#faq" },
];

export const heroPoints = [
  "The Billionaire MBA from empire builders.",
  "Secrets of the #1 startup accelerator.",
  "What raises your odds before day one.",
];

export const learnings = [
  "The “Billionaire MBA” principles that apply from the first decision through much larger scale",
  "Secrets of the #1 startup accelerator in the world",
  "What actually raises the odds before you spend the first dollar or make the first hire",
  "The difference between the support friends and family can give and the guidance that changes outcomes",
  "How operators who lasted avoided the most common early mistakes",
];

export const bookParts = [
  {
    part: "Part I",
    title: "The Billionaire MBA",
    tagline: "Avoiding the three ways entrepreneurship dies",
    paragraphs: [
      "There are three reliable places companies go to die: entrepreneurial burnout, business-model fragility, and scaling failure. They keep success rates near 21–30%, even for people who have already “made it” once.",
      "Part I inverts them with frameworks from three empire builders: Milisci on founder energy so the work doesn’t burn you out, Binion on business models that survive beyond the first win, and Alexander on empire-building that doesn’t collapse when you try to grow.",
    ],
    takeaway:
      "The things that would have killed your company can be named and designed around before you start.",
    stories: [] as { venture: string; failureMode: string }[],
  },
  {
    part: "Part II",
    title: "The Mentored Path",
    tagline: "Four stories of application",
    paragraphs: [
      "If Part I is the diagnosis from the mentors, Part II is the application: four of the author’s own ventures, each inverting one of the remaining failure modes.",
    ],
    takeaway:
      "Mentorship in written form, closing the gap between knowing and doing, and ending with what the mentored path looks like for you.",
    stories: [
      { venture: "A real-estate exit", failureMode: "Business operation failure" },
      { venture: "Y Combinator", failureMode: "Capital failure" },
      { venture: "A 9-figure tech company", failureMode: "Marketing failure" },
      { venture: "An entrepreneur mastermind", failureMode: "Community failure" },
    ],
  },
];

export const bonuses = [
  "eBook available to purchase for $1",
  "Live Q&A with the author for pre-order readers",
  "Early access to Chapter 1, sent today",
];

export const faqs = [
  {
    question: "When will my book arrive?",
    answer:
      "The Mentored Founder launches on November 1, 2026. Everyone on the launch list will hear from us as soon as it’s available.",
  },
  {
    question: "Will I be charged now?",
    answer:
      "No. Pre-ordering simply adds you to the launch list, plus gives you access to purchase the eBook at a discount ($1).",
  },
  {
    question: "How do I get the pre-order bonuses?",
    answer:
      "Your bonuses are emailed to you right after you pre-order. The live Q&A invitation goes out shortly before release.",
  },
];
